module.exports = __webpack_public_path__ + "static/media/femaleSuggestion.0079c21d.jpg";